
























import {Component, Mixins} from 'vue-property-decorator'
import BannerMixin from "@/helpers/mixins/BannerMixin";
import ProductCard from "@/helpers/mixins/ProductCard";

@Component
export default class NewGoodsBanner extends Mixins(BannerMixin, ProductCard) {
}
